import { render, staticRenderFns } from "./RequestsStatistics.vue?vue&type=template&id=19544b4f&scoped=true&"
import script from "./RequestsStatistics.vue?vue&type=script&lang=js&"
export * from "./RequestsStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=19544b4f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19544b4f",
  null
  
)

export default component.exports